import { ActionTypes } from "./act_types"
import { $getTranslations } from "../requests"
import { DropitState, getTranslationsByScope } from "../reducers"
import { toastr } from "react-redux-toastr"
import { responseType, transform } from "../../utils/http-res-handler"

export const fetchTranslations =
  () => (dispatch: (callback: object) => void, getState: () => DropitState) => {
    $getTranslations()
      .then((res) =>
        transform(
          res,
          getTranslationsByScope(getState(), "toastrLabels"),
          responseType.json
        )
      )
      .then((rawResponse: any) => {
        const response = rawResponse.translations.reduce(
          (accumulator: any, r: any) => {
            return Object.assign(accumulator, {
              [r.scope]: Object.assign(accumulator[r.scope] || {}, {
                [r.name]: r.text,
              }),
            })
          },
          {}
        )
        dispatch({
          type: ActionTypes.FETCH_TRANSLATIONS,
          response,
        })
      })
      .catch((err) => {
        toastr.error(
          err.message ? err.message : "Impossible de contacter le server.",
          ""
        )
        return err
      })
  }
